import {
  GET_PARENT_EVENTS_REQUEST,
  GET_PARENT_EVENTS_SUCCESS,
  GET_PARENT_EVENTS_FAILURE,
  SPORTSBOOK_EVENTS_DUELLOCHILD_WS_UPDATE,
  TOGGLE_DUELLO_DETAIL,
  RESET_TOOGLE_DUELLO_DETAIL
} from 'Store/constants';

export const initialState = {
  loading: false,
  parentEvents: {},
};
  
export default (state = initialState, action) => {
  
  switch (action.type) {
    case GET_PARENT_EVENTS_REQUEST: {
      return {
        ...state,
        loading: true,
      };
    }
  
    case GET_PARENT_EVENTS_SUCCESS: {
      const { parentEventId, events } = action.payload;

      const newChilds = events?.reduce((acc, event) => {
        acc[event.id] = { ...event, parentEventId: parentEventId };
        return acc;
      }, {});

      return {
        ...state,
        parentEvents: {
          ...state.parentEvents,
          [parentEventId]: { eventIds: events.map(e=>e.id), isOpen: state.parentEvents?.[parentEventId]?.isOpen }
        },
        childEvents: {
          ...state.childEvents,
          ...newChilds
        },
        loading: false,
      };
    }

    case TOGGLE_DUELLO_DETAIL: {
      const { eventId, value } = action.payload;

      return {
        ...state,
        parentEvents: {
          ...state.parentEvents,
          [eventId]: { ...state.parentEvents[eventId], isOpen: value }
        },
      };
    }

    case RESET_TOOGLE_DUELLO_DETAIL: {
      const newParentEvents = Object.entries(state?.parentEvents)?.reduce((acc, parent) => {
        const key = parent[0];
        const value = parent[1];
        acc[key] = { ...value, isOpen: false };
        return acc;
      }, {});

      return {
        ...state,
        parentEvents: {
          ...newParentEvents
        },
      };
    }
  
    case SPORTSBOOK_EVENTS_DUELLOCHILD_WS_UPDATE: {
      const { newEvent } = action.payload;

      return {
        ...state,
        childEvents: {
          ...state.childEvents,
          [newEvent.id]: newEvent
        },
      };
    }

    case GET_PARENT_EVENTS_FAILURE: {
      return {
        ...state,
        loading: false,
      };
    }
  
    default:
      return state;
  }
};
  